import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {oceanImportMblList, TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,
  ExportRowRenderer,
  ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";

import constants from '../../../constants';
import MoveTypeDropDown from "../../../uiControls/MoveTypeDropDown";
import {Search} from "../../../filtering";

import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import periodCloseIcon from '../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../img/periodclose-12.svg';
import opCloseIcon from '../../../img/OPClose.svg';
import opCloseIcon2 from '../../../img/opclose-12.svg';
import accountCloseIcon from '../../../img/AccountClose.svg';
import accountCloseIcon2 from '../../../img/accountingclose-12.svg';

import cntrBlue from '../../../img/cntr-tracking-rq-12-blue.svg';

import {
  DateRenderer,DateTimeRenderer,
  FloatRenderer,
  NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../ApplicationContext';
import JobListViewContext, {IJobListViewContext, RightClickContext} from '../../common/JobListViewContext';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import PrimaryButton from '../../../ui/PrimaryButton';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import IfmsModal from '../../../ui/IfmsModal';
import {JobNames} from '../../../framework.core/JobNames';
import {OiMblListItem, OimListType} from '../../../fms.data/models/OiMblListItem';
import * as XCol from '../../../framework.core/XExportColumn';

import MblMilestonePopup from './MblMilestonePopup';
import fastStorage from '../../../fastStorage';
import Menu, {IfmsMenuItem} from '../../../ui/menu/Menu';
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import PrimaryInverseButton from '../../../ui/PrimaryInverseButton';
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { ShipmentTypeRenderer, ShipmentTypeFilterRenderer, LclFclFilterRenderer, BillInvoiceCrdbFilterRenderer, LclFclRenderer, RecognizedFilterRenderer, RecognizedRenderer, BillingsRenderer, TrackEventNameRenderer, LastEventRenderer, RQFilterEventRenderer, changeRQEvent, OIShipmentTypeFilterRenderer } from '../../common/commonListRenderers';
import { FmsSecTask } from '../../../fms.core/constants';
import { getFmsGlobal } from '../../../globals';
import TrackingRequest from '../../reports/TrackingRequest';
import _ from 'lodash';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';
import { findSecurityTask, findSecurityTaskWithBranch, getSecBySecTask } from '../../../util';
import { useJournal } from '../../accounting/general/journal/JournalListView';
import RecogModal from '../../../ui/RecogModal';
import useSetEditedId from '../../../hooks/useSetEditedId';
import { formatLclFcl, formatShipmentType } from '../../common/utils/formatUtils';
import { formatDateTime } from '../../../dateUtils';
import { displayLastTrackingEvent, nullableCheckBoxValue } from '../../common/commonExportFormat';
import { OiHblListItem } from '../../../fms.data/models/OiHblListItem';
import IconButton, { BillingsIconButton, DeleteHistoryIconButton, DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, JournalIconButton, RecogHistoryIconButton, ViewIconButton, ViewIconButton2 } from '../../../ui/IconButton';
import TrackingRQIcon2 from '../../../img/toolbar-trackingrq-light.svg';
import TrackingRQIcon2_D from '../../../img/toolbar-trackingrq-dark.svg';
import TrackingRQIcon3 from '../../../img/cntr-tracking-rq-light.svg';
import TrackingRQIcon3_D from '../../../img/cntr-tracking-rq-dark.svg';
import { SecType } from '../../../fms.enum';
import JobSwitchingMenuContext from '../../jobSwitchingMenuContext';
import useJobMenus from '../../../hooks/useJobMenus';
import useListTrackingRequest, { getTrackRequestTitle } from '../../../hooks/useListTrackingRequest';
import taskReminderIconRed from '../../../img/pin_red.svg';
import { OiHbl } from '../../../fms.core/OiHbl';
import { AmsHistoryMasterArgs } from '../../../fms.report/args';
import { DocumentType } from '../../../framework.core/DocumentType';
import cntrGreen from '../../../img/cntr-tracking-rq-12-green.svg';
import SparkleIcon from '../../../img/ai-marker.svg';

function MoveTypeFilterRenderer({value, onChange}:any) {
  return (
    <MoveTypeDropDown
      name='ifms-filter-moveType-select'
      value={value}
      onChange={moveType => onChange(moveType)}
    />
  );
}

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];

  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';
  else if (lStatus === 'AC') dataTooltip = 'Accounting Close';

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt=""/>;
  else if (lStatus === 'OC')
    content = <img height="12px" src={opCloseIcon2} id={'blueIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt=""/>;
  else if (lStatus === 'AC')
    content = <img height="12px" src={accountCloseIcon2} id={'blackIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt=""/>;
  //}

  return (
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`}  data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function HblRenderer({value, data, row}: any) {
  const {switchToHblFor} = useMblOperations();

  if (value === '0') {
      return <div className="ifms-table-default">{value}</div>;
  }

  const isNumber = !isNaN(parseInt(value));
  if (!isNumber) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToHblFor(data[row.index])} style={{width: '100%', color: 'blue', fontWeight: 'bold', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}

function AgentRenderer({ cell, value, data, row }: any) {
  const agentCnt  = (data[row.index].agentCnt - 1);

  return ( 
    <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left">{value}{agentCnt > 0 ? ' + ' + agentCnt : ''}</div>
  );
}

function ContainerRenderer({ cell, value, data, row }: any) {
  const l = data[row.index];
  return (
    <div className="ifms-table-default" id={`oim-container-${cell.column.id}`} data-tooltip={l.fullContainerNo}>{value}</div>
  );
}



function useMblOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);

  function openDocServer(mbl:OiMblListItem|null){
    if (!mbl) {
      return;
    }

    if(appContext.appInfoAreaContent === 'none') appContext.setAppInfoAreaContent('memo'); 
  }

  function switchToHblFor(mbl:OiMblListItem|null) {
    const hblSec = findSecurityTask(appContext, FmsSecTask.OIHbl);
    if (!mbl || !hblSec.grantRead) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/hbl/oceanImport', 
      //'refNo', 'Ref No', mbl.refNo ?? '', 'updated', false
      // 'refNo', '', mbl.refNo ?? '', 'update', false);
      'oiMblId', 'Ref. #', mbl.id, 'u2Date', false, true, null, 'refNo', mbl.refNo,false,true);
    openNewPage(history, `/common/joblistview/hbl/oceanImport`, NavigationType.newPage);
  }

  function switchToContainerFor(mbl:OiMblListItem|null) {
    if (!mbl) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/OICN/oceanImport', 
      //'refNo', 'Ref No', mbl.refNo ?? '', 'updated', false
      // 'refNo', '', mbl.refNo ?? '', 'update', false);
      'oiMblId', 'Ref. #', mbl.id, '', false, true, null, 'refNo', mbl.refNo, false, true);
    openNewPage(history, `/common/joblistview/OICN/oceanImport`, NavigationType.newPage);
  }


  function switchToAmsFor(mbl:OiMblListItem|null) {
    if (!mbl) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/AMSM/oceanImport', 
    //'refNo', 'Ref No', mbl.refNo ?? '', 'updated', false
    // 'refNo', '', mbl.refNo ?? '', 'update', false);
    'amsLinkId', 'AMS ID', mbl.amsLinkId, '', false, true, null, null, null, false, true);
    openNewPage(history, `/common/joblistview/AMSM/oceanImport`, NavigationType.newPage);
  }

  async function switchToAcctInfo(mbl:OiMblListItem|null) {
    if (!mbl) {
      return;
    }
    
    openNewPage(history, `/accounting/Acct/${JobNames.OIMbl}/${mbl.id}`, NavigationType.newPage);
  }

  return { switchToHblFor, switchToContainerFor, switchToAmsFor ,switchToAcctInfo, openDocServer};
}

function useSelectedMblOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const context = useContext(JobSwitchingMenuContext);
  const {removeSingleJobMenuinTab} = useJobMenus();
  const { switchToHblFor, switchToContainerFor, switchToAmsFor } = useMblOperations();

  const selectedElement = jobListContext.selectedElement as OiMblListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  const { trackRequestFunc } = useListTrackingRequest({
    jobName: JobNames.OIMbl,
    getMblNo: () => selectedElement?.mblNo ?? '',
    getContainerNo: () => selectedElement?.containerNo ?? '',
    getTrType: () => selectedElement?.trType ?? '',
    getTrStatus: () => selectedElement?.trStatus ?? '',
    getJobId: () => selectedElement?.id ?? 0,
  });

  const setSavedEntityOih = useSetEditedId([JobNames.OIHbl]);
  
  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/oceanImport/mbl/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    openNewPage(history, '/oceanImport/mbl/add', NavigationType.newPage);
  }

  async function deleteMbl() {
    if (!selectedElement) {
      return;
    }

    if ((selectedElement.hblCount !== 'DBL' && selectedElement.hblCount !== 'SBL' && selectedElement.hblCount !== '0')) {
      await showGlobalOkDialog('Need to delete HBL first', false, null, "warning");
      return;
    }

    if (
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/OIMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/OIMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/OIMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/OIMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/view/OIMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/edit/OIMB/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Bill/Invoice/CrDb first', false, null, "warning");
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to Delete?</h3>
      </div>
    , false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.OIMbl, { id:selectedElement.id, pimsLinkId: selectedElement.pimsLinkId, sbl: selectedElement.sbl });
      if (apiResult && apiResult.success) {
          // List에서 데이터를 Delete할 때 해당 데이터가 View/Edit 모드로 Open 되어있으면 그 탭을 Close하도록 동작
          const editUrl = `/oceanImport/mbl/edit/${selectedElement.id}`;
          const viewUrl = `/oceanImport/mbl/view/${selectedElement.id}`;
        if (jobListContext.hasOpenedScreenStartingWithUrl(editUrl) || jobListContext.hasOpenedScreenStartingWithUrl(viewUrl)) {
            context.resetForCurrentJob();
            removeSingleJobMenuinTab(jobListContext.hasOpenedScreenStartingWithUrl(editUrl) ? editUrl : viewUrl,'');
        }

        jobListContext.reloadData();
        setSavedEntityOih('0', false, false, true);
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message, false, null, 'warning');
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/oceanImport/mbl/edit/${id}`;
    const viewUrl = `/oceanImport/mbl/view/${id}`;

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  // 기본적으로 View Mode로 동작하고 Edit 화면이 열려있는 경우 Edit 화면으로 이동.
  async function viewBillings() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const tabIndex = 2;
    const baseUrl = '/oceanImport/mbl';
    const editBaseUrl = `${baseUrl}/edit/${id}`;
    const viewBaseUrl = `${baseUrl}/view/${id}`;

    const isEditOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editBaseUrl);
    const isViewOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewBaseUrl);
    
    // View의 TabIndex 설정
    if (isEditOpen || isViewOpen) {
      const modeStr = isEditOpen ? 'edit' : 'view';
      fastStorage[`${modeStr}${JobNames.OIMbl}TabIndexRequest${id}`] = tabIndex;
    }
    
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(
      `${viewBaseUrl}/${tabIndex}`, [viewBaseUrl, editBaseUrl]);
  }

  // 기본적으로 View Mode로 동작하고 Edit 화면이 열려있는 경우 Edit 화면으로 이동.
  async function viewProfit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const tabIndex = 4;
    const baseUrl = '/oceanImport/mbl';
    const editBaseUrl = `${baseUrl}/edit/${id}`;
    const viewBaseUrl = `${baseUrl}/view/${id}`;

    const isEditOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editBaseUrl);
    const isViewOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewBaseUrl);

    // View의 TabIndex 설정
    if (isEditOpen || isViewOpen) {
      const modeStr = isEditOpen ? 'edit' : 'view';
      fastStorage[`${modeStr}${JobNames.OIMbl}TabIndexRequest${id}`] = tabIndex;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(
      `${viewBaseUrl}/${tabIndex}`, [viewBaseUrl, editBaseUrl]);
  }

  async function moveToDeleteHistoryReport() {
    const listSec = findSecurityTask(appContext, FmsSecTask.OIDeleteHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    const id = selectedElement?.id ?? 0;
    const viewUrl = `/common/deleteHistory?jobname=${JobNames.OIMbl}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function moveToRecogHistoryReport() {
    const listSec = findSecurityTask(appContext, FmsSecTask.OIRecogHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    const id = selectedElement?.id ?? 0;
    const viewUrl = `/common/recogHistory?jobname=${JobNames.OIMbl}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/oceanImport/mbl/edit/${id}`;
    const viewUrl = `/oceanImport/mbl/view/${id}`;
    
    const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OIMbl, selectedElement.branch);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl('/oceanImport/mbl/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/oceanImport/mbl/add?copyId=${id}`, NavigationType.newPage);
  }

  function switchToHbl() {
    const selectedElement = jobListContext.selectedElement as OiMblListItem;
    if (selectedElement?.hblCount !== 'DBL') switchToHblFor(selectedElement);
  }

  function switchToContainer() {
    const selectedElement = jobListContext.selectedElement as OiMblListItem;
    switchToContainerFor(selectedElement);
  }

  function switchToAms() {
    const selectedElement = jobListContext.selectedElement as OiMblListItem;
    switchToAmsFor(selectedElement);
  }

  function recognize(isSet: boolean) {
    jobListContext.setRecogModalData({ isOpen: true, isSet: isSet });
  }

  return { create, deleteMbl, edit, view, copy, switchToHbl, switchToContainer, switchToAms, recognize, viewBillings, moveToDeleteHistoryReport, moveToRecogHistoryReport, viewProfit, trackRequestFunc };
}

function useSelectedHblOperations() {
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const selectedElement = jobListContext.selectedElement as OiHblListItem;
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const setSavedEntityOim = useSetEditedId([JobNames.OIMbl]);

  async function createHbl() {
    if (jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/hbl/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const newUrl = `/oceanImport/hbl/add?mblRefId=${selectedElement.id}`;

    openNewPage(history, newUrl, NavigationType.newPage);
  }

  return { createHbl, setSavedEntityOim };
}

function RightClickMenu({dismiss, column, isStatus}:{dismiss: VoidFunction, column : number, isStatus : boolean}) {
  const { create, deleteMbl, edit, view, copy, switchToHbl, switchToContainer, switchToAms, recognize, viewBillings, viewProfit, trackRequestFunc } = useSelectedMblOperations();
  const { createHbl } = useSelectedHblOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as OiMblListItem;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OIMbl, selectedElement?.branch);
  const containerSec = findSecurityTask(appContext, FmsSecTask.OIContainer);
  const amsSec = findSecurityTask(appContext, FmsSecTask.AMSMaster);
  const hblSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OIHbl, selectedElement?.branch, true);
  const fmsGlobal = getFmsGlobal();
  const setSavedEntityAfterClose = useSetEditedId([JobNames.OIHbl]);
  const userID = appContext.user ? appContext.user.id ?? '' : '';

  function openContainerTracking() {
    window.open(`https://trackinginfo.suntekscm.com/?licid=${fmsGlobal.AcmeID}&mbl=${selectedElement.mblNo}`);
  }

  function openContainerStatus() {
    if (jobListContext.rowExtrasId) {
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(selectedElement.id);
  }

  async function processFileLock() {
    const fileLockResult = await appContext.api.opClose(JobNames.OIMbl, selectedElement.id, !selectedElement.isClosed);
    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult, false, null, 'warning');
      return;
    }

    const hasOpenedMbl =
      jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/mbl/edit/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/mbl/view/${selectedElement.id}`)

    if (selectedElement.isClosed && hasOpenedMbl) {
      const editModelKey = `editOiMbl${selectedElement.id}-/oceanImport/mbl/edit`;
      const viewModelKey = `viewOiMbl${selectedElement.id}-/oceanImport/mbl/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 0;
        fastStorage[keyMatch].isClosed = false;
        fastStorage[keyMatch].closedBy = '';
        fastStorage[keyMatch].closeDate = null;

        if (fastStorage[keyMatch].hblList) {
          fastStorage[keyMatch].hblList.forEach((hbl: OiHbl) => {
            hbl.fileClosed = 0;
          });
        }
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].fileClosed = 0;
        fastStorage[viewKeyMatch].isClosed = false;
        fastStorage[viewKeyMatch].closedBy = '';
        fastStorage[viewKeyMatch].closeDate = null;

        if (fastStorage[viewKeyMatch].hblList) {
          fastStorage[viewKeyMatch].hblList.forEach((hbl: OiHbl) => {
            hbl.fileClosed = 0;
          });
        }
      }

    } else if (!selectedElement.isClosed && hasOpenedMbl) {
      const editModelKey = `editOiMbl${selectedElement.id}-/oceanImport/mbl/edit`;
      const viewModelKey = `viewOiMbl${selectedElement.id}-/oceanImport/mbl/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
      const closeDate = await appContext.api.getFieldValueDate({
        id: selectedElement.id,
        tableName: 'T_OIMMAIN',
        fieldName: 'F_CloseDate'
      });

      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 1;
        fastStorage[keyMatch].isClosed = true;
        fastStorage[keyMatch].closedBy = userID;
        fastStorage[keyMatch].closeDate = closeDate;
        if (fastStorage[keyMatch].hblList) {
          fastStorage[keyMatch].hblList.forEach((hbl: OiHbl) => {
            hbl.fileClosed = 1;
          });
        }
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].fileClosed = 1;
        fastStorage[viewKeyMatch].isClosed = true;
        fastStorage[viewKeyMatch].closedBy = userID;
        fastStorage[viewKeyMatch].closeDate = closeDate;
        if (fastStorage[viewKeyMatch].hblList) {
          fastStorage[viewKeyMatch].hblList.forEach((hbl: OiHbl) => {
            hbl.fileClosed = 1;
          });
        }
      }

    }

    setSavedEntityAfterClose('0', false, false, true);
    jobListContext.reloadData();
  }

  async function processAccountLock() {
    const accountLockResult = await appContext.api.accountClose(JobNames.OIMbl, selectedElement.id, !selectedElement.isAccountClosed);
    if (!!accountLockResult) {
      await showGlobalOkDialog(accountLockResult,false,null,'warning');
      return;
    }

      const hasOpenedMbl =
    jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/mbl/edit/${selectedElement.id}`) ||
    jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/mbl/view/${selectedElement.id}`)

    if (selectedElement.isAccountClosed && hasOpenedMbl) {
      const editModelKey = `editOiMbl${selectedElement.id}-/oceanImport/mbl/edit`;
      const viewModelKey = `viewOiMbl${selectedElement.id}-/oceanImport/mbl/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
      if (keyMatch) {
        fastStorage[keyMatch].accountClosed = 0;
        fastStorage[keyMatch].isAccountClosed = false;
        fastStorage[keyMatch].accountClosedBy = '';
        fastStorage[keyMatch].accountCloseDate = null;
        if (fastStorage[keyMatch].hblList) {
          fastStorage[keyMatch].hblList.forEach((hbl: OiHbl) => {
            hbl.accountClosed = 0;
          });
        }


      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].accountClosed = 0;
        fastStorage[viewKeyMatch].isAccountClosed = false;
        fastStorage[viewKeyMatch].accountClosedBy = '';
        fastStorage[viewKeyMatch].accountCloseDate = null;
        if (fastStorage[viewKeyMatch].hblList) {
          fastStorage[viewKeyMatch].hblList.forEach((hbl: OiHbl) => {
            hbl.accountClosed = 0;
          });
        }
      }

      
    }else if (!selectedElement.isAccountClosed && hasOpenedMbl) {
      const editModelKey = `editOiMbl${selectedElement.id}-/oceanImport/mbl/edit`;
      const viewModelKey = `viewOiMbl${selectedElement.id}-/oceanImport/mbl/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
      const accountCloseDate = await appContext.api.getFieldValueDate({
        id: selectedElement.id,
        tableName: 'T_OIMMAIN',
        fieldName: 'F_AcctCloseDate'
      });

      if (keyMatch) {
        fastStorage[keyMatch].accountClosed = 1;
        fastStorage[keyMatch].isAccountClosed = true;
        fastStorage[keyMatch].accountClosedBy = userID;
        fastStorage[keyMatch].accountCloseDate = accountCloseDate;
        if (fastStorage[keyMatch].hblList) {
          fastStorage[keyMatch].hblList.forEach((hbl: OiHbl) => {
            hbl.accountClosed = 1;
          });
        }
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].accountClosed = 1;
        fastStorage[viewKeyMatch].isAccountClosed = true;
        fastStorage[viewKeyMatch].accountClosedBy = userID;
        fastStorage[viewKeyMatch].accountCloseDate = accountCloseDate;
        if ( fastStorage[viewKeyMatch].hblList) {
          fastStorage[viewKeyMatch].hblList.forEach((hbl: OiHbl) => {
            hbl.accountClosed = 1;
          });
        }
      }

    }
    
    setSavedEntityAfterClose('0', false, false, true);
    jobListContext.reloadData();
  }

  let showFileLock = (!selectedElement?.isClosed ? getFmsGlobal().CanFileLock : getFmsGlobal().CanFileUnlock) && listSec?.grantEdit;
  let showAccountLock = (!selectedElement?.isAccountClosed ? getFmsGlobal().CanAccountLock : getFmsGlobal().CanAccountUnlock) && listSec?.grantEdit;
  let isTracking = (selectedElement?.trStatus && selectedElement?.trStatus !== 'C' && selectedElement?.trStatus !== 'failed' && selectedElement?.trStatus !== 'Q') ?? false;
  // const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.status === 'PC' || selectedElement?.status === 'OC');
  const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.confirmDate??'') < (getFmsGlobal().CloseDate??'');
  const noBillingsShow = (fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = (fmsGlobal.NoProfitShow ?? false);  
  
  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: false, hidden: !listSec?.grantDel },
    { label: 'New HBL', shortcut: '', separator: true, disabled : ((selectedElement?.directBl || selectedElement.sbl) || !hblSec?.grantAdd) },
    { label: 'Go to Container List', shortcut: 'F4', separator: false, hidden: !containerSec?.grantRead },
    { label: 'Go to AMS List', shortcut: 'Shift+F4', separator: false, hidden : !amsSec?.grantRead},
    { label: 'Search', shortcut: 'F5', separator: false },
    // { label: 'Go to HBL List', shortcut: 'F6', separator: false, disabled : selectedElement?.hblCount === 'DBL' },
    { label: 'Go to HBL List', shortcut: 'F6', separator: false, hidden: !hblSec?.grantRead},
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: noBillingsShow && noProfitShow, hidden: !listSec?.grantAdd },
    { label: 'Billings', shortcut: 'F7', separator: noProfitShow, hidden: noBillingsShow },
    { label: 'Profit', shortcut: 'Ctrl+F7', separator: true, hidden: noProfitShow},
    { label: 'Container Status Update', shortcut: '', separator: false },
    { label: 'CNTR Tracking Info', shortcut: '', separator: false },
    { label: isTracking ? 'Request Email Notification' : 'Request Tracking Service', shortcut: '', separator: false, hidden: !listSec?.grantEdit },
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: false, hidden: !showFileLock },
    { label: !selectedElement?.isAccountClosed ? 'Accounting Close' : 'Accounting Open', shortcut: '', separator: false, hidden: !showAccountLock },
    // { label: 'Recog', shortcut: '', separator: false, disabled : selectedElement?.recognized === 'R', hidden: !getFmsGlobal().CanFinalize },
    { label: selectedElement?.recognized !== 'R' ? 'Recog' : 'Undo Recog', shortcut: '', separator: false, disabled : lockCancelRecog, hidden: !getFmsGlobal().CanFinalize || !listSec?.grantEdit },
  ];

  const itemStatus = [
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: false, hidden: !showFileLock },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) => ({
    label: <ToolboxMenuItem name="oim-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    disabled: i?.disabled ?? false,
    hidden: i?.hidden ?? false,
  }));
  
  const menuStatus: ActionButtonItem[] = itemStatus.map((i, index) => ({
    label: <ToolboxMenuItem name="oim-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    index,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteMbl();
        break;
      case 4:
        createHbl();
        break;
      case 5:
        switchToContainer();
        break;
      case 6:
        switchToAms();
        break;
      case 7:
        jobListContext.triggerTableSearch('F5');
        break;
      case 8:
        switchToHbl();
        break;
      case 9:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 10:
        copy();
        break;
      case 11:
        viewBillings();
        break;
      case 12:
        viewProfit();
        break;
      case 13:
        openContainerStatus();
        break;
      case 14:
        openContainerTracking();
        break;
      case 15:
        trackRequestFunc();
        break;
      case 16:
        processFileLock();
        break;
      case 17:
        processAccountLock();
        break;
      case 18:
        recognize(selectedElement?.recognized !== 'R');
        break;
      default:
        break;
    }
    dismiss();
  }

  function onStatusSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        processFileLock();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={(column === 0 && isStatus) ? splitMenuItemsIntoSections(menuStatus) :  splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={(column === 0 && isStatus) ? onStatusSelected : onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function ChbRenderer({ cell, row, data }: any) {
  const l = data[row.index];
  const tooltip = l.chbRspCode === 'x' ? undefined : `${l.chbRspCode} - ${l.chbRspMsg}`;

  return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default" data-tooltip={tooltip}>{cell.value}</div>;
}

function PaidRenderer({ value, data, row }: any) {
  const {switchToAcctInfo} = useMblOperations();

  const isPaid = value !== 'x';

  if (!isPaid) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToAcctInfo(data[row.index])} style={{width: '100%', lineHeight:'1em', textDecoration: 'underline'}}>{value}</PrimaryInverseButton>
}

function MemoDetailRenderer({value, data, row}: any) {
  const {openDocServer} = useMblOperations();

  const memoCnt = value;

  if(memoCnt === '0'){
    return <div className="ifms-table-default">{value}</div>;
  }

  return <div onClick={() => openDocServer(data[row.index])} style={{width: '100%', color: 'blue', fontWeight: 'bold', lineHeight:'1em', cursor:'pointer'}}>{value}</div>
}

function RefNoRenderer({value, data, row, cell}: any){
    
  const isPending = data[row.index].taskPendingCnt > 0;
  const isAiAgent = data[row.index].u1ID.toUpperCase() === '@AIAGENT';

    return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left">
      {value}
      {isAiAgent ? <img style={{marginBottom:'1px', marginLeft:'8px'}} src={SparkleIcon} /> : <></>}
      {isPending ? <img style={{marginBottom:'1px', marginLeft:'3px'}} width='11px' height='11px' src={taskReminderIconRed} /> : <></>}
     
    </div>
}


function AfterMemoLogButtonCommands() {
  return null;
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as OiMblListItem;
  const hasSelectedRow = !!selectedElement;
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OIMbl, selectedElement?.branch); 
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;

  const { trackRequestFunc } = useListTrackingRequest({
    jobName: JobNames.OIMbl,
    getMblNo: () => selectedElement?.mblNo ?? '',
    getContainerNo: () => selectedElement?.containerNo ?? '',
    getTrType: () => selectedElement?.trType ?? '',
    getTrStatus: () => selectedElement?.trStatus ?? '',
    getJobId: () => selectedElement?.id ?? 0,
  });

    return (
       <IconButton style={{ alignItems: 'center', justifyContent: 'center' }} iconHeight="24px" name='oim-list-trackingRq-button' disabled={!canBeEdit} onClick={trackRequestFunc} icon={appContext.useDarkMode ? TrackingRQIcon3_D : TrackingRQIcon3} data-tooltip={'CNTR Tracking RQ'} />
    ) ;   
   
}


function MblListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  
  const selectedElement = jobListContext.selectedElement as OiMblListItem;
  const { deleteMbl, edit, view, copy, viewBillings, viewProfit, moveToDeleteHistoryReport, moveToRecogHistoryReport, trackRequestFunc } = useSelectedMblOperations();

  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();

  const { viewReport } = useReportViewer();
  const appContext = useContext(ApplicationContext);
  const setSavedEntityAfterRecog = useSetEditedId([JobNames.OIHbl, JobNames.SlipJournal]);

  const {switchJournal} = useJournal();

  function doAfterRecog(){
    jobListContext.reloadData();
    setSavedEntityAfterRecog('0', false, false, true);
  }

  const onRecogModalClose = () => {
    jobListContext.setRecogModalData({ isOpen: false, isSet: false });
  }

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/mbl/add`);
  }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }
  
  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    if (fmsSubMenu === FmsSubMenu.STARCFSMANI) {
      var result = await appContext.api.makeCfsManifest(selectedElement?.id?.toString()||'0');
      if (result) {
        if (!result.item1) {
          await showGlobalOkDialog(<p>CFS/Contact not configured for email manifest. (Name='ediManifest', Dept=ID, EMail=Address).</p>, false, null, 'warning');
          return;
        } else if (result.item3){
          // FMS3.3 Code : FrmPrintPreview.RunEmptyReport(false, result.Item2, "Manifest", result.Item3, "T_OIMMAIN", tbId.ToInt());
          //await showGlobalOkDialog(<p>Not Implemented Yet <br/>(An email pop-up window should open.)</p>).then();
          return;
        }
      }
    } else {
      // Call ReportViewer 
      const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.OIMbl, selectedElement, appContext, showGlobalYesNoDialog, showGlobalOkDialog);
      if(args){
        viewReport(args, "", true);
      }
    }
  }

  const onLinkClick = (link: string) => {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    window.open(link);
  }
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OIMbl, selectedElement?.branch); 
  const userId = appContext.user?.id ?? '';
  const checkSecJournal = !getSecBySecTask(appContext, FmsSecTask.ListJournalOP, SecType.Read) && !userId?.startsWith('@');

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;

  const fmsGlobal = getFmsGlobal();
  const noBillingsShow = (fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = (fmsGlobal.NoProfitShow ?? false);  

  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
  return (
     <div className='ifms-common-no-vertical-separator-gap-margin'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
       <div className='ifms-common-vertical-gap-8'>
        <UniqueLinkButton newStyle name='oim-list-add-button' link="/oceanImport/mbl/add" disabled={!canBeAdd} useOnlyIcon label={''} data-tooltip='New' iconMode />
        <EditIconButton2 name='oim-list-edit-button' disabled={!canBeEdit} onClick={edit} data-tooltip='Edit' useText/>
        <ViewIconButton2 name='oim-list-view-button' disabled={!hasSelectedRow} onClick={view} data-tooltip='View' useText />
        <DeleteIconButton2 name='oim-list-delete-button' disabled={!canBeDeleted} onClick={deleteMbl} data-tooltip='Delete' useText/>
      </div>
      <div className='ifms-common-vertical-gap-8'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <PrimaryButton name='oim-list-copy-button' disabled={!canBeCopied} onClick={copy} size={'extrasmall'}>Copy/Paste</PrimaryButton>
      {!noBillingsShow && <BillingsIconButton name='oim-list-billings-button' data-tooltip={constants.List_Billings} onClick={viewBillings} useText/>}
      {!noProfitShow && <PrimaryButton name='oim-list-profit-button' onClick={viewProfit} size="extrasmall" >Profit</PrimaryButton>}
      <DeleteHistoryIconButton name='oim-list-deleteHistory-button' onClick={moveToDeleteHistoryReport} useText/>
      <RecogHistoryIconButton name='oim-list-recogHistory-button' onClick={moveToRecogHistoryReport} useText/>
      {!checkSecJournal && <JournalIconButton onClick={() =>     switchJournal(JobNames.OIMbl, selectedElement.id, "", null, selectedElement.refNo)} useText/>}
      </div>

      {jobListContext.trackingRequestModalState && (
        <IfmsModal
          isBlueHeader
          cancelOnEsc
          onCancel={() => {
            const id = jobListContext.trackingRequestModalState?.jobId;
            if (id != null) fastStorage[`oim-trackrequest-${id}`] = null;
            jobListContext.setTrackingRequestModalState(undefined);
          }}
          draggable
          isOpen
          title={getTrackRequestTitle(jobListContext.trackingRequestModalState.trStatus)}
          width="500px"
        >
          <TrackingRequest
            jobId={jobListContext.trackingRequestModalState.jobId}
            storageKey={`oim-trackrequest-${jobListContext.trackingRequestModalState.jobId}`}
            onClose={() => {
              const id = jobListContext.trackingRequestModalState?.jobId;
              if (id != null) fastStorage[`oim-trackrequest-${id}`] = null;
              jobListContext.setTrackingRequestModalState(undefined);
            }}
            jobName={JobNames.OIMbl}
            trStatus={jobListContext.trackingRequestModalState.trStatus}
            trType={jobListContext.trackingRequestModalState.trType}
            mode={jobListContext.trackingRequestModalState.mode}
            vcResult={jobListContext.trackingRequestModalState.vcResult}
            prefetchedGroupData={jobListContext.trackingRequestModalState.prefetchedGroupData}
          />
        </IfmsModal>
      )}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.link ? onLinkClick(selectedPopupMenuItem.link) : null}
      {jobListContext.recogModalData?.isOpen ? (
        <RecogModal reloadData={doAfterRecog} onCancel={onRecogModalClose} mTbId={selectedElement.id} mTbName={"T_OIMMAIN"} isSet={jobListContext.recogModalData?.isSet} ></RecogModal>
      ) : null}
    </div>
  );
}

function MblListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function formatData(data:Array<OiMblListItem>) {
  return data.map(d => ({
    ...d,
    // shipmentType: formatShipmentType(d.shipmentType),
  }));
}

function MblListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({ onFunction: onFunctionKey });

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as OiMblListItem;
  const history = useHistory();
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OIMbl, selectedElement?.branch);

  const { create, copy, edit, view, switchToHbl, switchToContainer, switchToAms, viewBillings, viewProfit } = useSelectedMblOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string|null>(null);
  const fmsGlobal = getFmsGlobal();
  const noBillingsShow = !(fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = !(fmsGlobal.NoProfitShow ?? false);  
  const hblSec = findSecurityTask(appContext, FmsSecTask.OIHbl);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
      if (hblSec.grantRead)
        switchToHbl();
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F4") {
      switchToContainer();
    } else if (unprocessedFkey === "SHIFT+F4") {
      switchToAms();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');
    } else if (unprocessedFkey === "F7") {
      if (noBillingsShow)
        viewBillings();
    } else if (unprocessedFkey === "CTRL+F7") {
      if (noProfitShow)
        viewProfit();
    }
    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey:string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F4', 'SHIFT+F4', 'F9', 'F11', 'F8', 'F7', 'CTRL+F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.OIMbl}
      jobId={selectedElement?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
      isDirectBl={(selectedElement?.hblCount??'') === 'DBL'}
      isSingleBl={(selectedElement?.hblCount??'') === 'SBL'}
    />
  );
}

/**
 * Concrete implementation for MBL List screen
 *
 * @class MblListView
 * @extends {AbstractListView}
 */
 class MblListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(JobNames.OIMbl, 'OiMblListItem',
      OiMblListItem.calculateSearchParameters(search, OiMblListItem.MapSearchFields, ['shipmentType', 'lclFcl', 'moveType']),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
     const apiResult = await api.getListItems(JobNames.OIMbl, 'OiMblListItem',
      OiMblListItem.calculateSearchParameters(search, OiMblListItem.MapSearchFields, ['shipmentType', 'lclFcl', 'moveType']),
      pageNum,
      limit,
      pageSize,
      pagePerBatch
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return formatData(apiResult.entities);
  }



  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      // {
      //   accessor: 'recognized',
      //   renderer: RecognizedFilterRenderer,
      //   searchValueExtractor: (v:any|null|undefined) => v,
      // },
      {
        accessor: 'shipmentType',
        renderer: OIShipmentTypeFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'lclFcl',   //'containerMode',
        renderer: LclFclFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      // {
      //   accessor: 're',
      //   renderer: RailFilterRenderer,
      //   searchValueExtractor: (v:any|null|undefined) => v,
      // },
      {
        accessor: 'moveType',
        renderer: MoveTypeFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'invStat',    //'inFlag',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v, 
      },
      {
        accessor: 'billStat',   //'biFlag',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'crDbStat', //crdbFlag',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'trStatus',
        renderer: RQFilterEventRenderer,
        searchValueExtractor: (v:any|null|undefined) => v !== null ? changeRQEvent(v): "",
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings, listCount: number, useDarkMode: boolean ): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;
    const listType = this.suntekSettings?.oceanAir?.useLotNumber ? OimListType.UseLot : OimListType.Normal;

    return OiMblListItem.getExportCollection(listType, useBranch).map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
     //else if(x.dataIndex === 'recognized') { colRenderer.Cell = RecognizedRenderer; }
      else if(x.dataIndex === 'memoCnt') { colRenderer.Cell = MemoDetailRenderer;}
      else if(x.dataIndex === 'refNo') {colRenderer.Cell = RefNoRenderer;}
      else if(x.dataIndex === 'invStat' || x.dataIndex === 'billStat' || x.dataIndex === 'crDbStat') colRenderer.Cell = BillingsRenderer;
      // { accessor:'hblCount', Cell: HblRenderer, Header: () => <span><u>HBL</u>(s)</span> },
      else if(x.dataIndex === 'hblCount') {
        colRenderer.Cell = HblRenderer;
        colRenderer.Header = () => <span><u>HBL</u>(s)</span>;
      }
      else if(x.dataIndex === 'agentName') colRenderer.Cell = AgentRenderer;
      else if (x.dataIndex === 'oFrt') colRenderer.Cell = PaidRenderer;
      else if (x.dataIndex === 'lastEvent') colRenderer.Cell = TrackEventNameRenderer;
      // else if (x.dataIndex === 're') { <250213 jhlee - R컬럼 제거 />
      //   colRenderer.Cell = RailRenderer;
      // }
      else if(x.dataIndex === 'trStatus'){
        colRenderer.Cell = (props: any) => <LastEventRenderer {...props} jobName={JobNames.OIMbl} />;;
        colRenderer.Header =  () => <div style={{gap:'4px', display:'flex'}}><img src={useDarkMode ? cntrGreen: cntrBlue} alt='' /><div>Container Tracking</div></div>;
      }
      else if(x.dataIndex === 'containerNo') {
        colRenderer.Cell = ContainerRenderer;
      }
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if(x.type === XCol.XCellType.Double) colRenderer.Cell = FloatRenderer;
      else if (x.dataIndex === 'chbRspCode') colRenderer.Cell = ChbRenderer;
      
      if (x.dataIndex === 'eBl' || x.dataIndex === 'expRls') {
        colRenderer.Cell = NullableCheckboxIconRenderer;
      }
      if (x.dataIndex === 'shipmentType') {
        colRenderer.Cell = ShipmentTypeRenderer;
      }
      if (x.dataIndex === 'lclFcl') {
        colRenderer.Cell = LclFclRenderer;
      }
      return colRenderer;
    });
  }

  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    //colRenderer.push({accessor: 'recognized', changedValue: (value: any)=> { return !value['recognized'] ? '' : value['recognized']}});
    colRenderer.push({accessor: 'lastEvent', changedValue: (value: any)=> { return (!!value['lastEvent'] ? value['lastEvent'] + ' ' + formatDateTime(value['lastEventDate']) : '')}});
    colRenderer.push({accessor: 'te', changedValue: (value: any)=> { return nullableCheckBoxValue(value['te'])}});
    colRenderer.push({accessor: 're', changedValue: (value: any)=> { return nullableCheckBoxValue(value['re'])}});
    colRenderer.push({accessor: 'eBl', changedValue: (value: any)=> { return nullableCheckBoxValue(value['eBl'])}});
    colRenderer.push({accessor: 'expRls', changedValue: (value: any)=> { return nullableCheckBoxValue(value['expRls'])}});
    colRenderer.push({accessor: 'shipmentType', changedValue: (value: any)=> { return formatShipmentType(value['shipmentType'])}});
    colRenderer.push({accessor: 'lclFcl', changedValue: (value: any)=> { return formatLclFcl(value['lclFcl'])}});
    colRenderer.push({accessor: 'trStatus', changedValue: (value: any)=> { return displayLastTrackingEvent(value)}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'createdAt',
      orderByAscending: false,
    };
  }

  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    //return oceanImportMblList;
    const tsettings = oceanImportMblList;
    const cols = OiMblListItem.getExportCollection(
      this.suntekSettings?.oceanAir?.useLotNumber ? OimListType.UseLot : (this.systemSettings?.isCanada ? OimListType.NormalCan : OimListType.Normal), 
      systemSettings?.enableBranch ?? false
      );

    // const getFilterType = (x: XCol.XExportColumn) => {
    //   if (x.dataIndex === 'eBl' || x.dataIndex === 'expRls')
    //   return XCol.XCellType.String;
    // }

    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;

  }

   renderCommands() {
     return (
       <MblListCommands />
     );
   }

  renderBeforeConfigureButton() {
    return (
      <MblListToolbar />
    );
  }

  renderExtras(hideLogHistory: boolean) {
    return <MblListViewExtras hideLogHistory={hideLogHistory} />
  }

  getViewUrlFor(row: OiMblListItem) {
    return row && row.id ? `/oceanImport/mbl/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'MBL List';
  };

   renderRowExtras(rowId: number | null, context: IJobListViewContext, cell: any, appContext: any): React.ReactNode | null {
     if (!rowId) {
       return null;
     }
     const selectedElement = context.selectedElement as OiMblListItem;
     const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OIMbl, selectedElement?.branch);

     function onCloseMilestonePopup() {
       const storageKey = `oi-mbl-milestone-${rowId}`;
       fastStorage[storageKey] = null;
       context.setRowExtrasId(null);
     }

     return (
       <IfmsModal isBlueHeader cancelOnEsc onCancel={onCloseMilestonePopup} draggable isOpen title="Container Status Update" width="760px">
         <MblMilestonePopup mblId={rowId} storageKey={`oi-mbl-milestone-${rowId}`} onClose={onCloseMilestonePopup} isView={!listSec?.grantEdit} />
       </IfmsModal>
     );
   }


   renderAdditionalCommands() {
     return <JobListSuntekCommand jobName={JobNames.OIMbl} keyProp='id' showAdjustBalance={false} />;
   }

   hasRightClickContext(): boolean {
     return true;
   }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} column={context.column} isStatus = {context.status}/>;
  }

  commandsAfterFilterBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }

  useLogHistory(): boolean {
    return true;
  }
};

export default MblListView;

